<template>
  <div>
    <div>
      <div class="card mb-5 mb-3">
        <div class="card-header">
          <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý phát
              thanh</span></h3>
        </div>
        <div class="card-body">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <label>Tên:</label>
              <el-row :gutter="10">
                <el-col :xs="20" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-input placeholder="Tên bản ghi..." v-model="search.cTen" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <label>Trạng thái:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                    <el-option label="Tất cả" value="-1" selected></el-option>
                    <el-option label="Hoạt động" value="1" selected></el-option>
                    <el-option label="Đã xóa" value="0" selected></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <label>Loại:</label>
              <el-row :gutter="10">
                <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                  <el-select placeholder="Tất cả" v-model="search.cLoai">
                    <el-option label="Tất cả" value="" selected></el-option>
                    <el-option label="Phát lại" value="REPLAY" selected></el-option>
                    <el-option label="Trực tiếp" value="LIVE" selected></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                  <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                      class="fa fa-search"></i></el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="card data-table mb-5 mb-xl-10">
        <div class="card-header py-3">
          <div class="body-function">
            <el-button type="primary" plain native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_broadcast">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm bản ghi</span>
            </el-button>
            <!-- <div class="col-md-6" style="text-align:right">
            <el-button plain icon="el-icon-refresh"  style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
              v-loading.fullscreen.lock="isLoading"></el-button>
          </div> -->
          </div>
        </div>
        <div class="card-body">
          <div class="col-md-12 tbl">
            <el-table :data="tableData.content" header-row-class-name="thead-light" height="100%" stripe
              highlight-current-row>
              <el-table-column prop="nMaPhatThanh" label="Mã" width="70" align="center"></el-table-column>
              <el-table-column prop="cTen" label="Tên Bản ghi" min-width="150" header-align="center">
              </el-table-column>
              <el-table-column prop="" label="Bản ghi" header-align="center" min-width="150">
                <template #default="scope">
                  <audio controls v-if="scope.row.cLoai == 'REPLAY'">
                    <source :src="((scope.row.cUrl.includes('/record/') ? baseUrl:'') + scope.row.cUrl )">
                  </audio>
                  <a v-else :href="scope.row.cUrl" target="_blank" class="text-nowrap">{{ scope.row.cUrl }}</a>
                </template>
              </el-table-column>
              <el-table-column prop="cLoai" label="Loại" width="150" align="center">
                <template #default="scope">
                  <el-tag effect="dark" type="warning" v-if="scope.row.cLoai == 'REPLAY'" size="small">Phát lại</el-tag>
                  <el-tag effect="dark" type="danger" v-if="scope.row.cLoai == 'LIVE'" size="small">Trực tiếp</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="dNgayTao" label="Ngày tạo" width="120" align="center">
                <template #default="scope">
                  <span v-if="scope.row.dNgayTao">{{
                    momentDate(scope.row.dNgayTao)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">
                <template #default="scope">
                  <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                  <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
                </template>
              </el-table-column>
              <!-- Button hành động -->
              <el-table-column width="150" align="center" label="Hành động">
                <template #default="scope">

                  <el-button type="primary" plain :disabled="scope.row.nTinhTrang == 0"
                    @click="handleOpenEdit(scope.row)" data-bs-toggle="modal" data-bs-target="#modal_broadcast">
                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                  </el-button>

                  <el-button type="danger" plain :disabled="scope.row.nTinhTrang == 0"
                    v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="col-12 py-2 pagination" style="justify-content: end">
          <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
            :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal_broadcast" ref="broadcastModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-650px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_broadcast_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm bản ghi" : "Cập nhật bản ghi" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="150px"
              class="d-flex flex-column ">
              <el-form-item label="Tên bản ghi" prop="cTen">
                <el-input v-model="formData.cTen" />
              </el-form-item>
              <el-form-item label="Loại bản ghi" prop="cLoai">
                <el-select placeholder="Chọn loại bản ghi" v-model="formData.cLoai" style="width: 30%;">
                  <el-option label="Phát lại" :value="'REPLAY'"></el-option>
                  <el-option label="Trực tiếp" :value="'LIVE'"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Loại lưu trữ" prop="" v-if="formData.cLoai == 'REPLAY'">
                <el-radio-group v-model="isFile">
                  <el-radio :value="true" >File</el-radio>
                  <el-radio :value="false" >Đường dẫn</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="Bản ghi" prop="recordFile" v-if="isFile && formData.cLoai == 'REPLAY'">
                <el-upload action="#" :auto-upload="false" placeholder="Chọn bản ghi" ref="upload"
                  :file-list="formData.recordFile" style="width: 30%; min-width: 200px;" :on-change="handleChangeFile"
                  :on-remove="handleRemoveFile">
                  <el-button type="primary">Chọn file</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="Đường dẫn" prop="cUrl" v-if="formData.cLoai == 'LIVE' || !isFile">
                <el-input v-model="formData.cUrl" />
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Broadcasts } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from "@/utils/global";
import { ElMessage } from "element-plus";
export default {
  name: 'broadcast',
  data() {
    return {
      search: {
        cTen: '',
        nTinhTrang: "-1",
        cLoai: "",
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        cTen: "",
        cUrl: "",
        cLoai: "",
        recordFile: []
      },
      rules: {
        cTen: [{ required: true, message: "Xin vui lòng điền tên bản ghi", trigger: "blur" }],
        cUrl: [{ required: true, message: "Xin vui lòng điền đường dẫn", trigger: "blur" }],
        cLoai: [{ required: true, message: "Xin vui lòng chọn loại bản ghi", trigger: "blur" }],
        recordFile: [
          {
            required: true, message: 'Xin vui lòng chọn bản ghi', trigger: 'change', validator: (rule, value, callback) => {
              if (this.formData.cLoai == 'REPLAY' && this.recordFile.length === 0) {
                callback(new Error('Xin vui lòng chọn bản ghi'));
              } else {
                callback();
              }
            }
          },
        ],
      },
      tableData: {
        content: [],
        totalSize: 0
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      recordFile: [],
      store: useStore(),
      isFile: false,
      baseUrl:baseUrl
    }
  },
  watch: {
    modalVisible() {
      if (!this.modalVisible) {
        this.recordFile = []
      }
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formData.resetFields()
      this.isFile = false
      this.modalVisible = true
      this.operation = false
      this.formData = {}
    },
    handleOpenEdit(val) {
      this.$refs.formData.resetFields()
      this.isFile = false
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
    },
    handleClose() {
      this.modalVisible = false
      hideModal(this.$refs.broadcastModalRef)

    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa bản ghi này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Broadcasts.deleteBroadcastsById, val.nMaPhatThanh).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa bản ghi thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa bản ghi thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleCLoseIframe() {
      this.openIframe = false
      this.iframeURL = ""
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cTen: { value: this.search.cTen },
        nTinhTrang: { value: this.search.nTinhTrang },
        cLoai: { value: this.search.cLoai },
      }
      this.store.dispatch(Broadcasts.findPageBroadcasts, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      })
      /* this.$api.broadcastings.findPage(this.pageRequest.pageNum, this.pageRequest.pageSize) */
    },
    async handleChangeFile(file, fileList) {
      this.recordFile = [file]
      this.formData.recordFile = this.recordFile
    },
    handleRemoveFile(file, fileList) {
      this.recordFile = []
      this.formData.recordFile = this.recordFile
    },
    handleSave() {
      this.$refs.formData.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu bản ghi này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          })
            .then(() => {
              const formData = new FormData();
              const data = {
                cTen: this.formData.cTen,
                cUrl: this.formData.cUrl,
                cLoai: this.formData.cLoai,
                nTinhTrang: 1
              }
              if (this.recordFile.length > 0 && this.formData.cLoai == "REPLAY") {
                if (this.recordFile[0].status == "ready") {
                  formData.append('file', this.recordFile[0].raw)
                }
              }
              if (this.operation) {
                data.id = this.formData.nMaPhatThanh
                formData.append('broadCastingRequest', new Blob([JSON.stringify(data)], { type: "application/json" }))
                this.store.dispatch(Broadcasts.updateBroadcasts, { id: data.id, formData: formData }).then(res => {
                  if (res.code == 200) {
                    ElMessage({ message: "Cập nhật bản ghi thành công", type: "success" });
                    this.handleClose()
                    this.handleFindPage()
                  }
                  else {
                    ElMessage({ message: res.msg, type: "error" });
                  }
                }).catch((error) => {
                  ElMessage({ message: "Cập nhật thất bại", type: "error" });
                })
              } else {
                formData.append('broadCastingRequest', new Blob([JSON.stringify(data)], { type: "application/json" }))
                this.store.dispatch(Broadcasts.saveBroadcasts, formData).then(res => {
                  if (res.code == 200) {
                    ElMessage({ message: "Thêm thành công", type: "success" });
                    this.handleClose()
                    this.handleFindPage()
                  }
                  else {
                    ElMessage({ message: res.msg, type: "error" });
                  }
                }).catch((error) => {
                  ElMessage({ message: "Thêm thất bại", type: "error" });
                })
              }

            }).catch(() => {

            })
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss"></style>